import React from 'react';
import { images } from '../../assets/images';
import './RecipeCard.css';

function RecipeCard({ recipe, onSelect }) {
  const recipeTitle =  recipe.title;
  const recipeImage = recipe.image || recipe.imageLink;
  const recipeCookTime = recipe.cookTime || recipe.cookingTime;
  const recipeServings = recipe.servings;

  const handleClick = () => {
    if (onSelect) {
      onSelect(recipe);
    }
  };

  return (
    <article className="recipe-card" onClick={handleClick} style={{ cursor: onSelect ? 'pointer' : 'default' }}>
      <div className="recipe-card-image-container">
        <img 
          src={recipeImage || images.christmasFood} 
          alt={recipeTitle} 
          className="recipe-card-image"
        />
        <div className="recipe-card-badges">
          <div className="recipe-badge">
            <img src={images.kitchenIcon} alt="" className="badge-icon" />
            <span className="badge-text">{recipeServings} people</span>
          </div>
          <div className="recipe-badge">
            <img src={images.clockIcon} alt="" className="badge-icon" />
            <span className="badge-text">{recipeCookTime}</span>
          </div>
        </div>
      </div>
      <div className="recipe-card-content">
        <h3 className="recipe-card-title">{recipeTitle}</h3>
      </div>
    </article>
  );
}

export default RecipeCard;
